var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1016 0H2.65586C1.22001 0 0 1.17076 0 2.60621V22.3968C0 23.8322 1.19419 25 2.63004 25L11.0897 24.9909C12.5253 24.9909 13.6999 23.8229 13.6999 22.3872L13.7122 2.60482C13.712 1.16421 12.5432 0 11.1016 0ZM5.65861 1.56254H8.10895C8.3242 1.56254 8.49953 1.73728 8.49953 1.95312C8.49953 2.16897 8.3242 2.34371 8.10895 2.34371H5.65861C5.44277 2.34371 5.26803 2.16897 5.26803 1.95312C5.26803 1.73728 5.44277 1.56254 5.65861 1.56254ZM4.18623 1.68684C4.33098 1.54228 4.59448 1.5403 4.73904 1.68684C4.81152 1.75912 4.85441 1.86059 4.85441 1.96424C4.85441 2.06591 4.81152 2.16718 4.73904 2.23966C4.66696 2.31213 4.56509 2.35483 4.46363 2.35483C4.36017 2.35483 4.26069 2.31213 4.18623 2.23966C4.11415 2.16738 4.07304 2.06591 4.07304 1.96424C4.07284 1.86059 4.11415 1.75912 4.18623 1.68684ZM6.80495 24.2258C6.1604 24.2258 5.63617 23.7012 5.63617 23.0568C5.63617 22.4123 6.1604 21.8878 6.80495 21.8878C7.4495 21.8878 7.97373 22.4123 7.97373 23.0568C7.97373 23.7012 7.44931 24.2258 6.80495 24.2258ZM12.4997 21.0934H1.36715V3.71105H12.4997V21.0934Z",
    fill: "#00C8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4ef6d94cd9a064e405a319c1c5b43f53.svg";
export { ForwardRef as ReactComponent };